<div class="d-flex align-items-center justify-content-center flex-wrap h-100" style="overflow: auto">
  <div *ngIf="isSpecialOffer" class="smartphone">
    <div class="dynamic-island"></div>
    <div class="d-flex flex-column justify-content-center h-100 w-100">
      <div class="text-muted" style="font-size: 1.7vh; margin: 0 2vh 1vh 2vh">Special Offers for You</div>
      <div class="special-offer" style="margin: 0 2vh 0 2vh">
        <div *ngFor="let item of elements" [ngSwitch]="item.tag">
          <div
            *ngSwitchCase="'img'"
            nbSpinnerStatus="info"
            [nbSpinner]="isLoading"
            class="special-offer-image-container"
          >
            <img *ngIf="!isLoading" [src]="item.value" [alt]="item.alt" height="100%" />
          </div>
          <div *ngSwitchCase="'b'" style="font-size: 1.6vh; line-height: 1.2em; margin: 2vh">
            {{ item.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="smartphone bg-white">
    <div class="dynamic-island"></div>
    <div class="close-button d-flex align-items-center justify-content-center">
      <nb-icon icon="close-outline" style="font-size: 3vh"></nb-icon>
    </div>
    <div class="d-flex flex-column h-100 w-100 overflow-auto" style="scrollbar-width: none">
      <div *ngFor="let item of elements" [ngSwitch]="item.tag">
        <div
          *ngSwitchCase="'img'"
          nbSpinnerStatus="info"
          [nbSpinner]="isLoading"
          [nbSpinnerMessage]="loadingMessage"
          class="image-container"
        >
          <img *ngIf="!isLoading" [src]="item.value" [alt]="item.alt" width="100%" />
        </div>
        <div *ngSwitchCase="'b'" class="notification-title">
          {{ item.value }}
        </div>
        <p *ngSwitchCase="'p'" class="notification-body">
          <span [innerHTML]="item.value"></span>
        </p>
        <p *ngSwitchCase="'warning'" class="notification-warning text-danger">
          {{ item.value }}
        </p>
      </div>
      <div *ngIf="button" class="d-flex mt-auto">
        <a class="notification-button" target="_blank" rel="noopener noreferrer" [href]="buttonLink">{{ button }}</a>
      </div>
    </div>
  </div>
  <div class="align-self-start m-3">
    <nb-card accent="info" class="m-0">
      <nb-card-header>
        <div class="d-flex">
          <div class="flex-grow-1 d-flex align-items-center justify-content-center">
            <nb-icon icon="smartphone-outline"></nb-icon>
            <div class="ml-2" i18n>Previewing Content</div>
          </div>
          <button nbButton class="ml-3" (click)="close()">
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </div>
      </nb-card-header>
      <nb-card-body style="overflow: unset">
        <div class="mb-2" style="font-weight: bold" i18n>Language:</div>
        <ng-select
          [(ngModel)]="language"
          id="language"
          name="language"
          (change)="languageChange($event)"
          style="font-weight: bold; width: 220px"
        >
          <ng-option
            *ngFor="let language of translationLanguages | keyvalue: sortAlphabeticallyByValue"
            [value]="language.key"
          >
            {{ language.value }}
          </ng-option>
        </ng-select>
      </nb-card-body>
    </nb-card>
  </div>
</div>
